import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { map } from 'rxjs';
import { SpaceRepository } from 'src/app/state/space.repository';
import { BoardItem } from '../../sessions/session/items-canvas/board-items/board.item';

@Component({
  selector: 'app-lock-snackbar',
  templateUrl: './lock-snackbar.component.html',
  styleUrls: ['./lock-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<LockSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public boardItem: BoardItem,
    private spaceRepo: SpaceRepository,
  ) {}

  isHost$ = this.spaceRepo.currentUserRole$.pipe(map((data) => data.owner));

  unlockAndDismiss(): void {
    this.boardItem.toggleLockState();
    this.snackBarRef.dismiss();
  }
}
